import type { CartItem, LMCartPreCheckRet } from "@/network/NetworkCart";
import { getCartNum } from "@/network/NetworkUser";
import { defineStore } from "pinia";

export interface CartConfirmInfo {
    items: CartItem[];
    preCheck: LMCartPreCheckRet;
}

export const useCartStore = defineStore("cart", () => {

    const confirmInfo = ref<CartConfirmInfo | null>(null);
    const cartNum = ref(0);
    const setConfirmInfo = (data: CartConfirmInfo) => {
        confirmInfo.value = data;
    };



    const clearConfirmInfo = () => {
        confirmInfo.value = null;
    };

    // 获取购物车数量
    const getCartCount = () => {
        getCartNum().then((res) => {
            cartNum.value = res.data.count;
        });
    };
    return {
        getCartCount,
        cartNum,
        confirmInfo,
        clearConfirmInfo,
        setConfirmInfo
    };
}, {
    persist: true// 持久化
}
);
